<template>
  <div class="loginWrap">
    <div class="login">
      <el-form ref="loginForm" :model="loginForm" :rules="loginFormRules" :label-width="type == 0 ? '100px' : '0'"
        @keydown.enter.native.prevent="login('loginForm')">
        <el-form-item :label="type == 0 ? '游戏账号:' : ''">
          <el-input v-model="loginForm.username" prop="username" maxlength="12"
            :placeholder="loginPlaceholder[type].name">
            <i slot="prefix" v-if="type == 1">
              <img class="header-icon" style="height: 26px" :src="login1" />
            </i>
          </el-input>
        </el-form-item>
        <el-form-item :label="type == 0 ? '登录密码:' : ''" prop="password">
          <el-input v-model="loginForm.password" :type="showPassword ? 'text' : 'password'" maxlength="18"
            :placeholder="loginPlaceholder[type].psw">
            <i slot="prefix" v-if="type == 1">
              <img class="header-icon" style="height: 26px" :src="login2" />
            </i>
            <!-- 用 append 插槽添加图标 -->
            <template #append>
              <i :class="showPassword ? 'el-icon-lock' : 'el-icon-view'" @click="showPassword = !showPassword"
                style="cursor: pointer; color: #909399"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="type == 0 ? '验证码:' : ''" prop="code">
          <div class="codeWrap">
            <el-input v-model="loginForm.code" :placeholder="loginPlaceholder[type].code">
              <i slot="prefix" v-if="type == 1">
                <img class="header-icon" style="height: 26px" :src="login3" />
              </i>
            </el-input>
            <span class="codeImg" @click="getCaptcha"><img :src="codeImg" alt="" width="58" height="36" /></span>
          </div>
        </el-form-item>
        <el-form-item class="submitWrap">
          <el-button class="btn" type="primary" @click="login('loginForm')">{{
            "立即登录"
          }}</el-button>
          <el-button v-if="type == 0" class="btn" @click="goRegister">注册</el-button>
        </el-form-item>
        <div class="forgetPsw">
          <span @click="handleForgetPsw">无法登录？点击找回</span>
          <span v-if="type == 0" @click="goRegister">马上注册，送好礼</span>
        </div>
      </el-form>
    </div>
    <el-dialog :visible.sync="isShowMask" :close-on-press-escape="false" :close-on-click-modal="false" width="600px">
      <div class="maskMain">
        <img class="closed" @click="closeMask" :src="closed" alt="" />
        <div class="title">登录验证</div>
        <el-form ref="phoneVerificationFrom">
          <!-- <input type="text" style="position: absolute;z-index:-999;left:-99999px;" />
          <input type="password" style="position: absolute;z-index:-999;left:-99999px;" /> -->
          <OtpInput v-model="code" @complete="handleComplete" />
          <el-form-item class="submitWrapBar">
            <div class="submitWrap">
              <!-- <div class="btnWrap" @click="submitPhoneVerification('phoneVerificationFrom')">
                <span>登录</span>
              </div> -->
              <span class="sendBtn" @click="getCode()" v-if="!modifyPswFormIsSendCode">获取手机验证码</span>
              <span class="sendBtn sendBtn1" v-else>{{ timerCount }}s</span>
              <!-- <div class="btnWrap cancel" @click="closeMask"><span>取消</span></div> -->
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import eventBus from "@/common/bus.js";
import OtpInput from "./component/OtpInput.vue";
export default {
  name: "login",
  props: {
    type: "", // 0:显示的是登录页的样式。1:显示的是首页的样式
  },
  components: { OtpInput },
  data() {
    return {
      // 验证弹窗
      isShowMask: false,
      // 验证码是否加载中
      codeLoading: false,
      // 关闭按钮
      closed: require("@/assets/imgs/public/close.png"),
      code: "",

      modifyPswFormIsSendCode: false, // 是否已经发送验证码
      timerCount: 60,
      showPassword: false, // 控制显示/隐藏的状态变量
      isShowPask: true,
      showSwitch: 2,
      login1: require("@/assets/imgs/menu/login1.png"),
      login2: require("@/assets/imgs/menu/login2.png"),
      login3: require("@/assets/imgs/menu/login3.png"),
      loginPlaceholder: [
        {
          name: "由6~12位数字或字母组成",
          psw: "由6~18位数字、字母、字符组成",
          code: "验证码",
        },
        { name: "账号", psw: "密码", code: "验证码" },
      ],
      codeImg: "",
      loginForm: {
        username: "",
        password: "",
        code: "",
        type: 1,
        source: "web",
      },
      loginFormRules: {
        username: [
          { required: true, message: "请输入游戏账号", trigger: "blur" },
          {
            required: true,
            pattern: /^([0-9A-Za-z]){6,12}$/,
            message: "游戏账号由6~12位数字或字母组成",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            required: true,
            pattern: /^[\w!@#$%^&*()-+=<>?]{6,18}$/i,
            message: "密码由6~18位数字、字母、字符组成",
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCaptcha();
  },
  mounted() {
    // this.loginCopy();
    this.init();
  },
  methods: {
    handleForgetPsw() {
      this.$emit("forgetPsw");
    }, // 忘记密码
    getCaptcha() {
      // 获取图片验证码
      axios({
        method: "get",
        url: "/login/getCaptcha",
        xhrFields: {
          withCredentials: true,
        },
        responseType: "arraybuffer",
      }).then((res) => {
        const setCookie = res.headers["Set-Cookie"];
        let imageType = res.headers["content-type"]; //获取图片类型
        const blob = new Blob([res.data], { type: imageType });
        const imageUrl = (window.URL || window.webkitURL).createObjectURL(blob);
        this.codeImg = imageUrl;
      });
    },

    login(loginForm) {
      // 立即登录
      this.$refs[loginForm].validate((valid) => {
        if (valid) {
          this.loginFun();
        }
      });
    },
    async loginFun() {
      let _this = this;
      await axios({
        method: "post",
        url: "/login/doLogin",
        xhrFields: {
          withCredentials: true,
        },
        data: {
          ...this.loginForm,
          smscode: this.code ? this.code : null,
        },
      })
        .then((res) => {
          if (res.data.state == 200) {
            this.$message.success(res.data.message);
            let seconds = 8 * 60 * 60; // 2*60*60;   2小时
            let expires = new Date(new Date() * 1 + seconds * 1000);
            this.resetSetItem("userInfo", JSON.stringify(res.data.data));

          Cookies.set("wx_token", res.data.data.token, { domain: ".qtthtech.com", expires: expires, }); //线上用
          Cookies.set("wx_userId", res.data.data.userId, { domain: ".qtthtech.com", expires: expires, });//线上用
           //Cookies.set("wx_token", res.data.data.token, { expires: expires }); //本地用
          // Cookies.set("wx_userId", res.data.data.userId, { expires: expires });//本地用
            this.$emit("loginSuccess");
            if (this.type == 0) {
              this.$router.push({
                path: "/",
              });
            }
          } else if (res.data.state == 501) {
            this.isShowMask = true;
          } else {
            this.$message.error(res.data.message);
            this.getCaptcha();
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 获取验证码封装
    async getCode() {
      if (this.codeLoading) {
        this.$message.error("正在获取，请稍后");
        return;
      }
      this.codeLoading = true;
      let _this = this;
      // window.nvc.getNVCValAsync(function (nvcVal) {
      try {
        const { ticket, randstr } = await this.$captcha();
        let data = {
          type: 11,
          // nvcVal: nvcVal,
          nvcVal: ticket,
          randStr: randstr,
          username: _this.loginForm.username,
          password: _this.loginForm.password,
          mobile: "",
          area: 86,
        };
        axios
          .post("/sms/sendMsg", data)
          .then((res) => {
            this.codeLoading = false;
            if (res.data.state == 200) {
              _this.$message.success(res.data.message);
              _this.modifyPswFormIsSendCode = true;
              _this.timer = setInterval(_this.countDown, 1000);
              _this.business_handle(res);
            } else {
              _this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            this.codeLoading = false;
            _this.$message.error(err.message);
          });
        // });
      } catch (err) {
        this.codeLoading = false;
        console.log("验证码失败：", err);
        this.$message.warning("验证未通过，请重试");
      }
    },
    countDown() {
      if (this.timerCount == 0) {
        this.timerCount = 60;
        this.modifyPswFormIsSendCode = false;
        this.yzmTxt = "重新获取";
        window.clearInterval(this.timer); // 清除定时器
        this.timer = null;
      } else {
        this.timerCount--;
      }
    }, // 倒计时

    closeMask() {
      this.isShowMask = false;
      this.code = "";
    },
    goRegister() {
      // 去注册页面
      this.$router.push({
        path: "/register",
      });
    },
    handleComplete(otp) {
      // 在这里调用接口，例如：
      // this.$axios.post("/api/verify", { code: otp })
      this.loginFun();
    },

    init() {
      let _this = this;
      var appKey = "FFFF0N1N00000000A7D3";
      var scene = "nvc_message";

      // 实例化nvc 对无痕验证进行初始化操作
      AWSC.use("nvc", function (state, module) {
        // 初始化 调用module.init进行初始化
        window.nvc = module.init({
          // 应用类型标识。它和使用场景标识（scene字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          appkey: appKey,
          //使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
          scene: scene,
          // 二次验证获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
          success: function (data) {
            window.console && console.log(data);
            _this.verificationData(data, "nc");
          },
          // 前端二次验证失败时触发该回调参数
          fail: function (failCode) {
            window.console && console.log("fail:" + failCode);
          },
          // 前端二次验证加载异常时触发该回调参数。
          error: function (errorCode) {
            window.console && console.log("error:" + errorCode);
          },
        });
      });
    },

    verificationData(data, type) { },
    // 处理业务返回结果：人机信息串上传接口的回调函数，通过业务服务端的返回结果，控制无痕验证的不同状态。
    business_handle(data) {
      // console.log(JSON.stringify(data));
      // 业务服务器请求回调控制是否需要二次验证
      if (data.code == "100" || data.code == "200") {
        // 无痕验证通过
        console.log("验证通过!");
        // 去注册或登录
      } else if (data.code == "800" || data.code == "900") {
        // 无痕验证失败，直接拦截
        console.log("验证失败!");
        // 跳转到账号密码页
        var ncoption = {
          // 声明滑动验证需要渲染的目标ID。
          renderTo: "nc",
          // 二次验证文案配置
          upLang: {
            cn: {
              //加载状态提示。
              LOADING: "加载中...",
              //等待滑动状态提示。
              SLIDE: "请向右滑动验证",
              //验证通过状态提示。
              SUCCESS: "验证通过",
              //验证失败触发拦截状态提示。
              ERROR: "非常抱歉，网络出错了...",
              //验证失败触发拦截状态提示。
              FAIL: "验证失败，请重试",
            },
          },
        };
        // 唤醒二次验证（滑动验证码）
        window.nvc.getNC(ncoption);
      } else if (data.code == "400") {
        // 无痕验证失败，触发二次验证
        // 二次验证码（滑动验证码）配置项设置，详情请见滑动验证集成方式文档
        // 二次验证的appkey，scene，test值及success，fail，error的回调由nvc初始化时决定，请不要在二次验证时传入
        var ncoption = {
          // 声明滑动验证需要渲染的目标ID。
          renderTo: "nc",
          // 二次验证文案配置
          upLang: {
            cn: {
              //加载状态提示。
              LOADING: "加载中...",
              //等待滑动状态提示。
              SLIDE: "请向右滑动验证",
              //验证通过状态提示。
              SUCCESS: "验证通过",
              //验证失败触发拦截状态提示。
              ERROR: "非常抱歉，网络出错了...",
              //验证失败触发拦截状态提示。
              FAIL: "验证失败，请重试",
            },
          },
        };
        // 唤醒二次验证（滑动验证码）
        window.nvc.getNC(ncoption);
      }
    },
  },
};
</script>

<style scoped lang="less">
.codeWrap {
  display: flex;

  .codeImg {
    margin-left: 10px;
  }
}

.maskMain {
  position: relative;
  z-index: 1;
  padding: 60px 100px;
  background: linear-gradient(#f6f1ff, #d7c5ff);
  border-radius: 10px;

  .closed {
    position: absolute;
    right: -35px;
    top: -38px;
    z-index: 1;
    cursor: pointer;
  }

  .title {
    margin-bottom: 20px;
    text-align: center;
    font-size: 30px;
    color: #333333;
    font-weight: 700;
  }

  .submitWrapBar {
    margin-bottom: 0 !important;

    .submitWrap {
      display: flex;
      justify-content: center;

      .sendBtn {
        margin-top: 20px;
        text-align: center;
        padding: 1px;
        width: 140px;
        height: 44px;
        line-height: 42px;
        background: #aa97ff;
        box-sizing: border-box;
        border-radius: 44px;
        overflow: hidden;
        color: #ffffff;
        font-weight: 600;
        cursor: pointer;
      }

      .cancel {
        background: #fca1f2;

        span {
          color: #fca1f2;
          background: #ffffff;
        }
      }
    }
  }
}

/deep/ .el-input {
  // border: 1px dashed #000000 !important;
  color: #000000 !important;

  .el-input-group__append {
    padding: 0 10px;
  }

  /deep/.el-input__inner::-webkit-input-placeholder {
    color: #746b6b !important;
  }
}

/deep/.el-dialog__header {
  display: none;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px;
  background: linear-gradient(#d7b7ff, #f9f8ff);
  border-radius: 10px;
}
</style>
